import React, { useState, } from "react"
import { Modal } from "react-bootstrap"

import TnSnapboxOtpStep1 from "./TnSnapboxOtpStep1"
import TnSnapboxOtpStep2 from "./TnSnapboxOtpStep2"
import classes from "./TnSnapboxOtpModal.module.scss"

const initialFormState = {
  mobilePhone: "",
  confirmCode: ""
}

const TnSnapboxOtpModal = props => {
  const {
    setSnapboxBalance,
    setNeedOtp,
    openOtpModal,
    setOpenOtpModal,
    selectedBranch
  } = props
  

  const [step, setStep] = useState(1)
  const [form, setForm] = useState(initialFormState)

  const handleExited = () => {
    setStep(1)
  }

  return (
    <Modal
      show={openOtpModal}
      onHide={() => setOpenOtpModal(false)}
      onExited={handleExited}
      centered
    >
      <div className={classes["container"]}>
        {
          step === 1 &&
          <TnSnapboxOtpStep1
            form={form}
            setForm={setForm}
            setStep={setStep}
            setOpenOtpModal={setOpenOtpModal}
          />
        }
        {
          step === 2 &&
          <TnSnapboxOtpStep2
            form={form}
            setForm={setForm}
            setStep={setStep}
            setSnapboxBalance={setSnapboxBalance}
            setNeedOtp={setNeedOtp}
            setOpenOtpModal={setOpenOtpModal}
            selectedBranch={selectedBranch}
          />
        }
      </div>
    </Modal>
  )
}

export default TnSnapboxOtpModal